import { ProgressBar } from 'react-aria-components';
import styled from 'styled-components';

export const Spinner = styled(ProgressBar)`
  position: absolute;
  left: calc(50% - 12px);

  & svg {
    width: 24px;
    animation-name: spin;
    animation-duration: 500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
